import { Switch } from "react-migration/components/Switch";
import { Theme } from "react-migration/lib/theme/Theme";
import { DeprecatedTooltip } from "react-migration/components/DeprecatedTooltip";

import { FC } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export interface FilterNewBuildsProps {
  disabled?: boolean;
  showNewBuildOnly: boolean;
  setShowNewBuildOnly: (value: boolean) => void;
  theme?: Theme;
}

export const FilterNewBuilds: FC<FilterNewBuildsProps> = ({
  disabled,
  showNewBuildOnly,
  setShowNewBuildOnly,
  theme = Theme.Light,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center mt-2" data-testid="filter-new-builds">
      <div className="flex flex-wrap">
        <Switch
          disabled={disabled}
          size="small"
          label="New Builds Only"
          showLabel={false}
          id="new-builds-only"
          onToggle={() => setShowNewBuildOnly(!showNewBuildOnly)}
          value={showNewBuildOnly}
        />
      </div>
      <label
        htmlFor="new-builds-only"
        className={`pl-2 font-semibold ${
          disabled ? `text-text-base-primary-disabled-${theme === Theme.Light ? "light" : "dark"}` : ""
        }`}
      >
        <span className="pr-2">{t("comparables.map.sidebar.filters.filters.newbuild")}</span>
        <DeprecatedTooltip
          theme={Theme.Light}
          placement="right"
          title={t("comparables.map.sidebar.filters.filters.newbuild.tooltip")}
          disabled={false}
          delayMs={1000}
          widthClass="w-80"
        >
          <i className="icon-lt-information-line text-lg cursor-pointer text-text-base-active" />
        </DeprecatedTooltip>
      </label>
    </div>
  );
};
